// 더보기 행 아이콘 — 시안 A4 심볼(building/user/translate/apps/info/power) 그대로. 이모지 금지.
// screens/SimpleMore.js(모바일 페이지)와 parts/WhoMenu.js(데스크톱 드롭다운)가 같이 쓴다.
import React from 'react';

function Glyph(props) {
  var st = { fill: 'none', stroke: 'currentColor', strokeWidth: 1.7, strokeLinecap: 'round', strokeLinejoin: 'round' };
  var body = props.id === 'building' ? <path d="M5 20V5.4h9V20M14 20h5V10h-5M8 9h3M8 12.6h3M8 16.2h3" {...st} />
    : props.id === 'user' ? <g {...st}><circle cx="12" cy="8.4" r="3.8" /><path d="M4.8 20c.6-3.7 3.6-5.8 7.2-5.8s6.6 2.1 7.2 5.8" /></g>
      : props.id === 'translate' ? <path d="M3.6 6h8.2M7.7 4v2M9.8 6c-.4 4.2-3.2 7.4-6.2 8.6M6.2 9.6c1 2.2 3 3.9 5.2 4.6M13 20l3.8-9.4L20.6 20M14.4 16.8h4.8" {...st} />
        : props.id === 'apps' ? <g {...st}><rect x="4" y="4" width="6.4" height="6.4" rx="1.6" /><rect x="13.6" y="4" width="6.4" height="6.4" rx="1.6" /><rect x="4" y="13.6" width="6.4" height="6.4" rx="1.6" /><rect x="13.6" y="13.6" width="6.4" height="6.4" rx="1.6" /></g>
          : props.id === 'power' ? <path d="M12 3.6v8M7.4 6.6a7.6 7.6 0 109.2 0" {...st} />
            : <g {...st}><circle cx="12" cy="12" r="8.6" /><path d="M12 11v5.4M12 7.8h.01" /></g>;
  return <svg width="17" height="17" viewBox="0 0 24 24" aria-hidden="true" focusable="false">{body}</svg>;
}

export default Glyph;
